import React from 'react'
import { X } from 'react-feather'

const MenuHeader = ({ title, onClose, className }) => {
  return (
    <div className={className}>
      <div className="py-6 px-5 border-b relative" style={{borderColor: '#ddd'}}>
        <div className="absolute left-0 pl-5" onClick={() => onClose(false)}><X width={20}/></div>
        <p className="text-center font-bold">{title}</p>
      </div>
    </div>
  )
}

export { MenuHeader }